import React from 'react'

const MenuIcon = props => {
  return (
    <svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 14">
      <path d="M7,17a1,1,0,0,1,0-2H25a1,1,0,0,1,0,2Zm0-6A1,1,0,0,1,7,9H25a1,1,0,0,1,0,2ZM7,23a1,1,0,0,1,0-2H25a1,1,0,0,1,0,2Z" transform="translate(-6 -9)"/>
    </svg>
  )
}

export default MenuIcon


// WEBPACK FOOTER //
// ./src/assets/icons/menu-icon.js